import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListActionsComponent } from './list-actions.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [ListActionsComponent],
  imports: [CommonModule, IconModule],
  exports: [ListActionsComponent],
})

export class ListActionsModule {}
